export function useQuickActionRouting() {}
